import { useEffect, useCallback } from 'react'

const PIXEL_ID = '846969475009809'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let pixelInitialized = false

function initPixel() {
  if (pixelInitialized || window.fbq) return
  pixelInitialized = true

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function useMetaPixel() {
  useEffect(() => {
    // Defer pixel loading so it doesn't block initial render
    if ('requestIdleCallback' in window) {
      ;(window as any).requestIdleCallback(initPixel)
    } else {
      setTimeout(initPixel, 100)
    }
  }, [])

  const trackAddToCart = useCallback(() => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Silencia a la Mamá Juez',
        content_type: 'product',
        value: 6.39,
        currency: 'USD',
      })
    }
  }, [])

  return { trackAddToCart }
}
